import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, central, fontSize }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  fontSize: theme.fontSize[fontSize || 'medium'],
  fontWeight: 'bold',
  color: 'white',
  extend: [
    {
      condition: central,
      style: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
  ],
});

const Group = ({ central, fontSize, children }) => {
  const { css } = useFela({ central, fontSize });

  return (
    <nav className={css(rules)}>
      {children}
    </nav>
  );
};

Group.propTypes = {
  central: PropTypes.bool,
  fontSize: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(Group);
